// extracted by mini-css-extract-plugin
export default {"wrapper":"docs-header_wrapper__WiX21"};